module.exports = __webpack_public_path__ + "files/4ec6a2eaebe2291e993abdf8d6b64907.png";